
import { requestViewConfiguration } from '../features/requests';
import { defaultViewData, defaultViewState, ViewData, ViewInformation, ViewState } from './types';
import { getAppCfg } from './app-cfg';
import { ASSETS_LIB_TABS, CODE_EDITOR, CONTENT_VIEW_NAME, EDITOR_VIEW_NAME, EMBED_VIEW_NAME, ERROR_VIEW_NAME, HELP_AREA_STATE, LAUNCH_VIEW_NAME, QUESTION_MODAL_STATE, NEXT_PROJECT_BUTTON, PROJECT_COORDINATES, RESULT_CODE, SHARE_MODAL_STATE, SHARE_PROJECT_STATE, STEP_POPPER, VIEW_DATA, LOGIN_REG_MODAL_STATE, STATS_STATE, TOAST_STATE, DATA_LIST, LIST_VIEW_NAME, PORTAL_VIEW_NAME, BACKEND_STATE, LECTURE_VIEW_NAME, DOCUMENTATION_VIEW_NAME, PARTY_USER_STATE, ONBOARDING_STATE, TASK_AREA_STATE, POPPER_HELPER, ERROR_HELP_STATE, DATA_VIEW_NAME, LOADING_VIEW_NAME, SOLUTION_AREA_STATE, ACHIEVEMENTS_STATE, ACHIEVEMENTS_VIEW_NAME, QUEST_VIEW_NAME, CHAT_VIEW_NAME, THEME } from './constants';
import { getStateValue, setStateValue, store } from './state';

const REGISTERED_VIEWS = [ERROR_VIEW_NAME, CONTENT_VIEW_NAME, EDITOR_VIEW_NAME, LAUNCH_VIEW_NAME, EMBED_VIEW_NAME, LIST_VIEW_NAME, PORTAL_VIEW_NAME, LECTURE_VIEW_NAME, DOCUMENTATION_VIEW_NAME, DATA_VIEW_NAME, LOADING_VIEW_NAME, ACHIEVEMENTS_VIEW_NAME, QUEST_VIEW_NAME, CHAT_VIEW_NAME];
const REGISTERED_COMPONENT_STATES = [PROJECT_COORDINATES, RESULT_CODE, NEXT_PROJECT_BUTTON, QUESTION_MODAL_STATE, STEP_POPPER,POPPER_HELPER, TASK_AREA_STATE, HELP_AREA_STATE, SOLUTION_AREA_STATE, ASSETS_LIB_TABS, CODE_EDITOR, SHARE_MODAL_STATE, SHARE_PROJECT_STATE, LOGIN_REG_MODAL_STATE, STATS_STATE, TOAST_STATE, DATA_LIST, BACKEND_STATE, PARTY_USER_STATE, ONBOARDING_STATE, ERROR_HELP_STATE, ACHIEVEMENTS_STATE, THEME];

const views : ViewState = {
  initialized: false,
  loading: true,
  currentView: "error"
}

export async function loadViews(viewList : ViewInformation[]) : Promise<void> {

  const currentViewState = getStateValue(VIEW_DATA);
  if (currentViewState.initialized === true) {
    return;
  }

  viewList.forEach(async (viewInfo) => {
    const viewCfg = await requestViewConfiguration(viewInfo.path);
    const oldState = store.getState(viewInfo.name);
    const viewData : ViewData = {
      ...oldState.getValue(),
      cfg : viewCfg
    }
    setStateValue(viewInfo.name, viewData);
    //console.log(`Loaded View: ${viewInfo.name}`, viewData);
  });

  views.initialized = true;
  views.loading = true;
  views.currentView = getAppCfg().view;

  setStateValue(VIEW_DATA, views);
  console.log(`Loaded Views: ${viewList.length}`);
}

export function getViewData(view : string) : ViewData {
  const viewState = getStateValue(VIEW_DATA);
  if (viewState.initialized === true) {
    const viewData = getStateValue(view);
    if (viewData.cfg) {
      return viewData;
    }
  }
  return defaultViewData;
}

export function setViewData(view : string, data : ViewData) : void {
  const viewData = getStateValue(VIEW_DATA);
  if (viewData.initialized === true) {
    setStateValue(view, data);
  }
}

export function getViewState() : ViewState {
  const viewData = getStateValue(VIEW_DATA);
  if (viewData.initialized === true) {
    return viewData;
  }
  return defaultViewState;
}

export function setViewState(newViewState : ViewState) : void {
  const viewData = getStateValue(VIEW_DATA);
  if (viewData.initialized === true) {
    setStateValue(VIEW_DATA, newViewState);
  }
}

export function setComponentData(componentName : string, data : any) : void {
  setStateValue(componentName, data);
}

export function getComponentData(componentName : string) : any {
  return getStateValue(componentName);
}

export function isViewInitialized() : boolean {
  const viewState = getStateValue(VIEW_DATA);
  return (viewState.initialized === true);
}


export function isViewLoading() : boolean {
  const viewState = getStateValue(VIEW_DATA);
  return (viewState.loading === true);
}

export function viewLoaded() {
  
  const viewState = getStateValue(VIEW_DATA);
  let newViewState = {
    ...viewState,
    loading : false
  }  
  setStateValue(VIEW_DATA, newViewState);
}


export function initViewStates() : void {
  store.setState(VIEW_DATA, {});
  REGISTERED_VIEWS.forEach(viewName => {
    store.setState(viewName, {});
  })

  REGISTERED_COMPONENT_STATES.forEach(componentName => {
    store.setState(componentName, {});
  })
}

export function showView(viewName : string) : void {
  console.log("show view", viewName)
  const viewState : ViewState = getViewState();
  if (viewState && viewState.currentView !== viewName) {
    viewState.currentView = viewName;
    setViewState(viewState);
  }
}

export function getCurrentViewName() : string {
  const viewState : ViewState = getViewState();
  if (!viewState) return "";
  return viewState.currentView;
}

export function getViewName(name : string) : string | undefined {
  return REGISTERED_VIEWS.find(viewName => viewName.includes(name));
}
